'use strict';
/*
 * Use this file to call functions in other files, on document ready, window.resize etc.
 */

var twentyninetimes = twentyninetimes || {};

// Document ready
document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    svg4everybody(); // Fix SVG spritemap in IE/Edge
  });

  twentyninetimes.siteHeader.init();
  twentyninetimes.navigation.init();
  twentyninetimes.loadMore.init();
  twentyninetimes.oembedOverlay.init();
  twentyninetimes.accordion.init();
  // twentyninetimes.backgroundJazz.init();
  twentyninetimes.tickets.init();
  // twentyninetimes.masonry.init();
  twentyninetimes.program.init();
  twentyninetimes.faqSearch.init();
  twentyninetimes.countdown.init();
  twentyninetimes.hourCountdown.init();
  twentyninetimes.sliders.init();
  twentyninetimes.formular.init();

  var splitSectionsIntoWords = document.querySelectorAll('.is-style-split-sentences, h1');
  if (splitSectionsIntoWords) {
    splitSectionsIntoWords.forEach((section) => {
      var results = Splitting({ target: section, by: 'words' });
    });
  }

  var inViewItems = document.querySelectorAll('.in-view-item, h1');
  if (inViewItems) {
    var test = (item) => {
      if (!item.classList.contains('visible')) {
        item.classList.add('visible');
      }

      if (item.classList.contains('is-style-split-sentences') || item.tagName == 'H1') {
        animateWords(item);
      }
    };
    twentyninetimes.inView.init(inViewItems, test, -100);
  }

  function animateWords(item) {
    if (item) {
      var words = item.querySelectorAll('.word');

      if (words) {
        function site_nav_item_timeout(i) {
          setTimeout(function () {
            words[i].classList.add('visible');
          }, i * 30);
        }

        for (var i = 0; i < words.length; i++) {
          site_nav_item_timeout(i);
        }
      }
    }
  }

  // var daysTop = document.querySelectorAll('#program .program-days .js-program-day-top');

  // Scroll functions
  window.onscroll = function () {
    // INSERT FUNCTIONS TO TRIGGER ON SCROLL

    twentyninetimes.siteHeader.checkScroll();
    // twentyninetimes.program.dayTopSticky(daysTop);
  };

  // Resize functions
  window.onresize = function () {
    // INSERT FUNCTIONS TO TRIGGER ON WINDOW RESIZE
  };


    // if the param "earlybird" is in the URL, add "earlybird" to the body class
    if (window.location.href.indexOf('earlybird') > -1) {
      document.body.classList.add('earlybird');
    }


});
